<template>
  <slot></slot>
</template>

<script lang="ts">
// @ts-nocheck - Watcher observer with dynamic subscription handling
import { defineComponent } from 'vue'

import { ElNotification } from 'element-plus'

import LangMixin from '@/lang/mixin/lang'
import { useCoreStore } from '@/stores/core'
import { IWatcher } from '@/types/shared'

export default defineComponent({
  name: 'WatcherObserver',
  components: {},
  mixins: [LangMixin],
  data() {
    const watchWatcherQuery = {}

    return {
      watchWatcherQuery,
    }
  },
  computed: {
    errorWatchers: {
      get() {
        return useCoreStore().errorWatchers
      },
      set(watchers: IWatcher[]) {
        useCoreStore().errorWatchers = watchers
      },
    },
  },
  watch: {
    errorWatchers: [
      {
        handler: 'notifyAlert',
      },
    ],
  },
  mounted(): void {
    this.watchWatchers()
  },
  methods: {
    beforeUnmount() {
      if (this.watchWatcherQuery) {
        this.watchWatcherQuery.unsubscribe()
      }
    },
    async watchWatchers() {
      useCoreStore()
        .watchWatchers()
        .then(res => {
          this.watchWatcherQuery = res
        })
    },
    handleAlertClick(watcher: IWatcher) {
      console.log('handleAlertClick', watcher)
    },
    notifyAlert() {
      if (this.errorWatchers.length > 0) {
        this.errorWatchers.forEach((watcher: IWatcher) => {
          ElNotification({
            type: watcher.alert ? 'error' : 'success',
            dangerouslyUseHTMLString: true,
            duration: 6000,
            offset: 84,
            customClass: 'no-print',
            title: watcher.alert
              ? this.$t('watchers.alertErrorTitle')
              : this.$t('watchers.alertSuccessTitle'),
            message: watcher.alert
              ? this.$t('watchers.alertErrorMessage', { name: this.getValueByLang(watcher.name) })
              : this.$t('watchers.alertSuccessMessage', {
                name: this.getValueByLang(watcher.name),
              }),
            onClick: () => this.handleAlertClick(watcher),
          })
        })

        this.errorWatchers = []
      }
    },
  },
})
</script>

<style lang="scss" scoped></style>
